import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'iview'
// import {maker} from '@form-create/iview'


import {
  setToken,
  getToken,
  canTurnTo,
  setTitle,
  backendMenusToRouters
} from "@/libs/util";
import config from "@/config";

const {homeName} = config;

Vue.use(Router)
const router = new Router({
  routes,
  mode: "history"
});
const LOGIN_PAGE_NAME = "login";

const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, store.state.user.menus)) {
    // 有权限，可访问
    next();
  } else {
    next({
      replace: true,
      name: "login"
    });
  } // 无权限，重定向到401页面
};

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  store.state.app.currentPage = to.name;
  const token = getToken();
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页 login/1
    // setToken("");
    next({
      name: homeName // 跳转到homeName页
    });
  } else if (token && !to.name) {
    // 已登录且要跳转的页面是登录页 /login
    next({
      name: homeName // 跳转到homeName页
    });
  } else {
    if (!store.state.user.userInfo.id) {
      store.dispatch("getUserInfo");
      store.dispatch("initChromeApp");
      store.dispatch("initAllSkuCover");
      store.dispatch("initAllSupplier");
      store.dispatch("initPage");
      store.dispatch("getDeliverySetting");
      store.dispatch("queryTurnoverBoxList");
      // store.dispatch("queryOperationList");
    }
    next();
  }
});

router.afterEach(to => {
  setTitle(to, router.app);
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js